import { render, staticRenderFns } from "./SvgAsset.vue?vue&type=template&id=773ab354"
import script from "./SvgAsset.vue?vue&type=script&lang=js"
export * from "./SvgAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports